// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyB9jAf2UYqLHcuuv96TIoqnZeUSaypQLdU",
  authDomain: "carhaat-373c2.firebaseapp.com",
  projectId: "carhaat-373c2",
  storageBucket: "carhaat-373c2.appspot.com",
  messagingSenderId: "972233738585",
  appId: "1:972233738585:web:2978d9abbc22bb792de448",
};
export default firebaseConfig;
